import { Injectable } from '@angular/core';
import { DeviceDto, DeviceValuesDto } from '../../../../../../api-main';

@Injectable({
  providedIn: 'root',
})
export class SelectingValueDataService {
  savedDevice: Record<string, DeviceDto[]> = {};

  savedDeviceValues: Record<string, DeviceValuesDto[]> = {};
}
